export enum LoginRoute {
  Login,
  EnterOTP,
  ForgotPassword,
  ConfirmForgotPassword,
}
